import {useHistory} from 'react-router-dom';
import {OperatoryOverviewListResponseProps} from './index';
import LiveTimeProgressBar from '../../common/time_progress_bar/LiveTimeProgressBar';
import TotalTime from './TotalTime';
import classNames from 'classnames';
import {ProcessCode} from '../../processes/types';
import {calculateAndFormatTimeHHMMSS} from '../../processes/helpers';
import {AlertSettingsProps, AlertSettingsResponseProps} from '../../settings/alert_alarm/types';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';

type OperatoriesElementProps = {
  data: OperatoryOverviewListResponseProps,
  processesAlertData: Nullable<AlertSettingsResponseProps>,
}

const OperatoriesElement: FC<OperatoriesElementProps> = ({
  data,
  processesAlertData
}) => {
  const {t} = useTranslation('operatories');
  const {number, process, desc} = data || {};
  const {
    id: processId,
    startedAt,
    type,
    treatment,
    patient,
    currentTask,
    completedAt,
    targetTime,
    status
  } = process || {};
  const history = useHistory();

  const operatoriesElementClassName = classNames('operatories-element', {
    ['disabled']: !processId
  });

  const openProcessDetails = () => {
    if (processId) {
      history.push(`/processes/running/${processId}`);
    }
  };

  const processTypeAlertSettings = processesAlertData?.length && process &&
    processesAlertData.find(
        (item: AlertSettingsProps) => item.processType === type.code) || null;

  return (
    <div className={operatoriesElementClassName} onClick={openProcessDetails}>
      <div className="number">
        <Tooltip title={desc}>
          <div>{number}</div>
        </Tooltip>
      </div>
      {!!processId ?
        <div className="content">
          <div className="row row--header">
            <div className="col">
              <span className="title">{t('overview.headerLabels.treatment')}</span>
              <span className="value">{treatment && treatment.displayName}</span>
            </div>
            <div className="col">
              <span className="title">{t('overview.headerLabels.currentTask')}</span>
              <span className="value">{currentTask?.type && currentTask.type.description}</span>
            </div>
            <div className="col">
              <span className="title">{t('overview.headerLabels.process')}</span>
              <span className="value">{type && type.description}</span>
            </div>
          </div>
          <div className="row row--footer">
            <div className="col">
              <span className="title">{t('overview.headerLabels.patient')}</span>
              <span className="value">{patient && `${patient.firstName} ${patient.lastName}`}</span>
            </div>
            <div className="col">
              <span className="title">{t('overview.headerLabels.teamMember')}</span>
              <span className="value">{currentTask?.assignee && `${currentTask.assignee.firstName} ${currentTask.assignee.lastName}`}</span>
            </div>
            <div className="row row--time">
              <div className="col col--total-time">
                <span className="title">{t('overview.headerLabels.totalTime')}</span>
                <TotalTime startedAt={startedAt} />
              </div>
              <LiveTimeProgressBar
                startedAt={startedAt}
                completedAt={completedAt}
                targetTime={targetTime}
                alertSettings={processTypeAlertSettings}
                isCurrentlyRunning={status === ProcessCode.RUNNING}
                processExpiredTimeFormat={calculateAndFormatTimeHHMMSS}
              />
            </div>
          </div>
        </div> :
        <div className="number free-operatory">{t('overview.freeOperatoryMsg')}</div>
      }
    </div>
  );
};

export default OperatoriesElement;
